// extracted by mini-css-extract-plugin
export default {"ctaSection":"CTASection_ctaSection__P003w","textContent":"CTASection_textContent__Jw2NJ","heading":"CTASection_heading__ERiOW","ctaButton":"CTASection_ctaButton__ffoSQ"};